<template>
    <div class="rcp p-3">
        <h6 class="mb-3">Point du couloir</h6>
        <div class="rcp-row">
            <span class="text-muted">Latitude</span>
            <span>{{ lat }}</span>
        </div>
        <div class="rcp-row">
            <span class="text-muted">Longitude</span>
            <span>{{ lng }}</span>
        </div>
        <div class="rcp-row">
            <span class="text-muted">Radius</span>
            <span class="d-inline-flex align-items-center gap-2">
                <input type="number" class="form-control form-control-sm" style="width: 110px" min="0"
                    :disabled="saving" v-model.number="editingRadius" />
                <span>m</span>
                <small v-if="isDefaultDisplay" class="text-danger ms-1">(défaut)</small>
            </span>
        </div>
        <div class="rcp-row">
            <span class="text-muted">Distance précédente</span>
            <span>
                {{ prevDisplay }}
                <span v-if="position?.prevDistance">m</span>
            </span>
        </div>
        <div class="rcp-row">
            <span class="text-muted">Distance suivante</span>
            <span>
                {{ nextDisplay }}
                <span v-if="position?.nextDistance">m</span>
            </span>
        </div>
        <div class="d-grid mt-3">
            <button class="btn btn-primary btn-sm" :disabled="saving || !isValid" @click="onSave">
                <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
                Enregistrer le radius
            </button>
            <small v-if="!isValid" class="text-danger mt-2">Veuillez saisir un radius valide (≥ 0).</small>
        </div>
    </div>
</template>

<script>
export default {
    name: "RightCorridoringPointPanel",
    props: {
        position: { type: Object, required: true },
        saving: { type: Boolean, default: false },
    },
    data() {
        return {
            editingRadius: this.position?.radius ?? 200,
        };
    },
    watch: {
        // Quand on change de "position" sélectionnée, on resynchronise le champ
        position: {
            handler(p) {
                this.editingRadius = (p?.radius ?? 200);
            },
            deep: false,
        },
    },
    emits: ["update-radius"],
    computed: {
        lat() {
            const v = Number(this.position?.latitude);
            return Number.isFinite(v) ? v.toFixed(6) : "—";
        },
        lng() {
            const v = Number(this.position?.longitude);
            return Number.isFinite(v) ? v.toFixed(6) : "—";
        },
        isDefaultDisplay() {
            return !this.position?.radius;
        },
        prevDisplay() {
            const v = this.position?.prevDistance;
            return Number.isFinite(v) ? v : "—";
        },
        nextDisplay() {
            const v = this.position?.nextDistance;
            return Number.isFinite(v) ? v : "—";
        },
        isValid() {
            const v = Number(this.editingRadius);
            return Number.isFinite(v) && v >= 0;
        },
    },
    methods: {
        onSave() {
            if (!this.isValid) return;
            // Délègue l’appel réseau au parent (map) via un event
            this.$emit("update-radius", Math.max(0, Math.round(Number(this.editingRadius))));
        },
    },
};
</script>

<style scoped>
.rcp {
    font-size: .95rem;
}

.rcp-row {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    padding: .35rem .25rem;
    border-bottom: 1px dashed #f1f3f5;
}

.rcp-row:last-child {
    border-bottom: 0;
}
</style>
